const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider', 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType Signature (using 'SignatureProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status is-expanded signature-preview-container">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							{~Required:Record~}
							{~Disabled:Record~}
							data-validation-surface="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							value=""
						/>
						<img
							id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="signature-preview-image" alt="Signature preview"
							{~Disabled:Record~}
							onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false, null, {~D:Record.PictForm.Disabled~});"
						/>
						<button
							type="button"
							class="button is-small is-link signature-edit-button"
							title="Edit Signature" aria-label="Edit signature"
							{~Disabled:Record~}
							onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false, null, {~D:Record.PictForm.Disabled~});"
						>
							<span class="icon is-small"><i class="fas fa-pen"></i></span>
						</button>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider', 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType Signature (using 'SignatureProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status is-expanded signature-preview-container">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									{~Required:Record~}
									{~Disabled:Record~}
									data-validation-surface="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
									value=""
								/>
								<img
									id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="signature-preview-image" alt="Signature preview"
									{~Disabled:Record~}
									onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false, null, {~D:Record.PictForm.Disabled~});"
								/>
								<button
									type="button"
									class="button is-small is-link signature-edit-button"
									title="Edit Signature" aria-label="Edit signature"
									{~Disabled:Record~}
									onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', false, null, {~D:Record.PictForm.Disabled~});"
								>
									<span class="icon is-small"><i class="fas fa-pen"></i></span>
								</button>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider', 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Signature (using SignatureProvider) {~D:Record.Hash~} {~D:Record.InputType~} -->
			<div class="field mb-0">
				<p class="control control-status is-expanded signature-preview-container">
					<span class="control-status-icon"></span>
					<input
						id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="hidden"
						{~D:Record.Macro.InformaryTabular~}
						{~Required:Record~}
						{~Disabled:Record~}
						data-validation-surface="TABULAR-SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider', 'InputValidation' ],
			Template: /*HTML-Partial*/`
						value=""
					/>
					<img
						id="TABULAR-SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						class="signature-preview-image" alt="Signature preview"
						{~Disabled:Record~}
						onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', true, {~D:Context[2].Key~}, {~D:Record.PictForm.Disabled~});"
					/>
					<button
						type="button"
						class="button is-small is-link signature-edit-button"
						title="Edit Signature" aria-label="Edit signature"
						{~Disabled:Record~}
						onclick="{~P~}.providers.SignatureProvider.openSignatureModal('{~D:Record.Macro.RawHTMLID~}', '{~D:Context[0].Hash~}', '{~D:Record.Hash~}', true, {~D:Context[2].Key~}, {~D:Record.PictForm.Disabled~});"
					>
						<span class="icon is-small"><i class="fas fa-pen"></i></span>
					</button>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML*/`
			<!-- InputType Signature (using SignatureProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="hidden"
						{~D:Record.Macro.InputFullProperties~}
						{~Required:Record~}
						{~Disabled:Record~}
						value=""
					/>
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control is-expanded">
						<img
							id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="signature-preview-image" alt="Signature preview"
						/>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML*/`
			<!-- InputType Signature (using 'SignatureProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							{~D:Record.Macro.InputFullProperties~}
							{~Required:Record~}
							{~Disabled:Record~}
							value=""
						/>
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<img
							id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="signature-preview-image" alt="Signature preview"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Signature (using SignatureProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control is-expanded">
				<input
					id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					{~D:Record.Macro.InformaryTabular~}
					{~Required:Record~}
					{~Disabled:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML-Partial*/`
					value=""
				/>
				<img
					id="TABULAR-SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="signature-preview-image" alt="Signature preview"
				/>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML*/`
			<!-- InputType Signature {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<input
						id="{~D:Record.Macro.RawHTMLID~}"
						type="hidden"
						{~D:Record.Macro.InputFullProperties~}
						{~Required:Record~}
						{~Disabled:Record~}
						value=""
					/>
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control is-expanded">
						<img
							id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="signature-preview-image print-only-signature-preview" alt="Signature preview"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML*/`
			<!-- InputType Signature (using 'SignatureProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="hidden"
							{~D:Record.Macro.InputFullProperties~}
							{~Required:Record~}
							{~Disabled:Record~}
							value=""
						/>
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<img
							id="SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="signature-preview-image print-only-signature-preview" alt="Signature preview"
						/>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Signature (using SignatureProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="control is-expanded">
				<input
					id="TABULAR-DATA-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					{~D:Record.Macro.InformaryTabular~}
					{~Required:Record~}
					{~Disabled:Record~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Signature',
			DefaultInputExtensions: [ 'SignatureProvider' ],
			Template: /*HTML-Partial*/`
					value=""
				/>
				<img
					id="TABULAR-SIGNATURE-PREVIEW-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					class="signature-preview-image print-only-signature-preview" alt="Signature preview"
				/>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
